/* eslint-disable no-nested-ternary */
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

const { Table, Select } = vp;

type PerformanceOverviewTableProps = {
  transactionOptions: {
    [key: string]: string;
  };
  performingTab: string;
  periodTab: string;
  performanceData: {
    Statistics: {
      [StatType: string]: {
        numOfData: {
          yearly: number;
          monthly: number;
          weekly: number;
        };
        volOfData: {
          yearly: number;
          monthly: number;
          weekly: number;
        };
      };
    };
  };
};

type StatusKeyValuePair = {
  name: string;
  value: number;
};

type FC = FunctionComponent<PerformanceOverviewTableProps>;

const PerformanceOverviewTable: FC = (props: PerformanceOverviewTableProps) => {
  const { transactionOptions, performingTab, periodTab, performanceData } = props;
  const [transaction, setTransaction] = useState('Num');
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage.PerformanceOverviewWidget' });

  const handleTransactionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTransaction(event.currentTarget.value);
  };

  const PerformanceOverviewRows: StatusKeyValuePair[] =
    // descending order
    periodTab === 'Yearly' && transaction === 'Num' && performingTab === 'Top'
      ? Object.entries(performanceData.Statistics)
          .map(([companyName, data]) => ({
            name: companyName,
            value: Number(data.numOfData.yearly),
          }))
          .sort((a, b) => b.value - a.value)
      : periodTab === 'Monthly' && transaction === 'Num' && performingTab === 'Top'
        ? Object.entries(performanceData.Statistics)
            .map(([companyName, data]) => ({
              name: companyName,
              value: Number(data.numOfData.monthly),
            }))
            .sort((a, b) => b.value - a.value)
        : periodTab === 'Weekly' && transaction === 'Num' && performingTab === 'Top'
          ? Object.entries(performanceData.Statistics)
              .map(([companyName, data]) => ({
                name: companyName,
                value: Number(data.numOfData.weekly),
              }))
              .sort((a, b) => b.value - a.value)
          : periodTab === 'Yearly' && transaction === 'Vol' && performingTab === 'Top'
            ? Object.entries(performanceData.Statistics)
                .map(([companyName, data]) => ({
                  name: companyName,
                  value: Number(data.volOfData.yearly),
                }))
                .sort((a, b) => b.value - a.value)
            : periodTab === 'Monthly' && transaction === 'Vol' && performingTab === 'Top'
              ? Object.entries(performanceData.Statistics)
                  .map(([companyName, data]) => ({
                    name: companyName,
                    value: Number(data.volOfData.monthly),
                  }))
                  .sort((a, b) => b.value - a.value)
              : periodTab === 'Weekly' && transaction === 'Vol' && performingTab === 'Top'
                ? Object.entries(performanceData.Statistics)
                    .map(([companyName, data]) => ({
                      name: companyName,
                      value: Number(data.volOfData.weekly),
                    }))
                    .sort((a, b) => b.value - a.value)
                : // ascending order
                  periodTab === 'Yearly' && transaction === 'Num' && performingTab === 'Low'
                  ? Object.entries(performanceData.Statistics)
                      .map(([companyName, data]) => ({
                        name: companyName,
                        value: Number(data.numOfData.yearly),
                      }))
                      .sort((a, b) => a.value - b.value)
                  : periodTab === 'Monthly' && transaction === 'Num' && performingTab === 'Low'
                    ? Object.entries(performanceData.Statistics)
                        .map(([companyName, data]) => ({
                          name: companyName,
                          value: Number(data.numOfData.monthly),
                        }))
                        .sort((a, b) => a.value - b.value)
                    : periodTab === 'Weekly' && transaction === 'Num' && performingTab === 'Low'
                      ? Object.entries(performanceData.Statistics)
                          .map(([companyName, data]) => ({
                            name: companyName,
                            value: Number(data.numOfData.weekly),
                          }))
                          .sort((a, b) => a.value - b.value)
                      : periodTab === 'Yearly' && transaction === 'Vol' && performingTab === 'Low'
                        ? Object.entries(performanceData.Statistics)
                            .map(([companyName, data]) => ({
                              name: companyName,
                              value: Number(data.volOfData.yearly),
                            }))
                            .sort((a, b) => a.value - b.value)
                        : periodTab === 'Monthly' && transaction === 'Vol' && performingTab === 'Low'
                          ? Object.entries(performanceData.Statistics)
                              .map(([companyName, data]) => ({
                                name: companyName,
                                value: Number(data.volOfData.monthly),
                              }))
                              .sort((a, b) => a.value - b.value)
                          : periodTab === 'Weekly' && transaction === 'Vol' && performingTab === 'Low'
                            ? Object.entries(performanceData.Statistics)
                                .map(([companyName, data]) => ({
                                  name: companyName,
                                  value: Number(data.volOfData.weekly),
                                }))
                                .sort((a, b) => a.value - b.value)
                            : [];

  const tableProps: vp.TableProps = {
    name: 'performance-overview-table',
    variant: 'overview',
    columns: {
      statusKey: { header: t('company') },
      value: {
        header: (
          <Select
            variant="chart"
            options={transactionOptions}
            placeholder={transactionOptions.Num}
            name="performance-overview-transactiion-select"
            value={transaction}
            onBlur={() => {}}
            onChange={handleTransactionChange}
          />
        ),
      },
    },
    rows: PerformanceOverviewRows.map(({ name, value }) => ({
      statusKey: name,
      value: transaction === 'Num' ? `$${value.toLocaleString()}` : value.toLocaleString(),
    })),
  };

  return <Table {...tableProps} />;
};

export default PerformanceOverviewTable;
